/**
 * NOJU: keep mobile hamburger drawer on desktop (same country picker + menu).
 * Horizon's setHeaderMenuStyle() otherwise sets data-menu-style=menu on non-touch.
 */
(function () {
  function forceDrawer() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    if (header.getAttribute('data-menu-style') !== 'drawer') {
      header.setAttribute('data-menu-style', 'drawer');
    }
  }

  forceDrawer();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceDrawer);
  }
  window.addEventListener('load', forceDrawer);
  window.addEventListener('resize', forceDrawer);

  var header = document.querySelector('#header-component');
  if (header && typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      forceDrawer();
    }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
  }

  // Re-assert after Horizon utilities update header custom properties
  var tries = 0;
  var timer = setInterval(function () {
    forceDrawer();
    tries += 1;
    if (tries > 20) clearInterval(timer);
  }, 100);
})();
